import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'patients');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'providers',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['providerUserId'],
    },
    'patients',
    {
      type: 'payload.query',
      queryParameter: 'query',
      selector: 'query',
    },
  ],
});

export default createReqReducer(consts);

// GET /api/providers/:provider_user_id/patients
// query



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/patients-by-provider-req.js